<app-channel-rate-mappings-table [showActions]="true"></app-channel-rate-mappings-table>
